/* eslint-disable react/prefer-es6-class, react/prefer-stateless-function, react/no-multi-comp */
import React from 'react';
import { Choice, Choices } from 'es6/components/common/choices';
import { GoalSource, ItemSource } from 'es6/models/session-config';
import Localization from 'es6/services/localization';

/**
 * Labels property should be a key for the corresponding size. The label
 * will default to the value if none is specified.
 *
 * Example:
 * 'sizes': [5, 10, 20]
 */
export const ChoicesSessionSize = React.createClass({
  displayName: 'ChoicesSessionSize',

  propTypes: {
    sessionConfig: React.PropTypes.object.isRequired,
    sizes: React.PropTypes.array.isRequired,
  },

  render() {
    const sessionConfig = this.props.sessionConfig;

    // Create the choices.
    const choices = this.props.sizes.map((size) => {
      const disabled = sessionConfig.isDisabled('sessionSize', size);
      return (<Choice key={size} disabled={disabled} value={size}>{size}</Choice>);
    });

    return (
      <Choices {...this.props} value={sessionConfig.sessionSize}>{choices}</Choices>
    );
  },
});

export const ChoicesItemSource = React.createClass({
  displayName: 'ChoicesItemSource',

  propTypes: {
    sessionConfig: React.PropTypes.object.isRequired,
  },

  render() {
    const sessionConfig = this.props.sessionConfig;

    return (
      <Choices {...this.props} value={this.props.sessionConfig.itemSource}>
        <Choice disabled={sessionConfig.isDisabled('itemSource', ItemSource.ALL)} value={ItemSource.ALL}>{Localization.t('js_iknow.recommended')}</Choice>
        <Choice disabled={sessionConfig.isDisabled('itemSource', ItemSource.REVIEW)} value={ItemSource.REVIEW}>{Localization.t('review-only')}</Choice>
        <Choice disabled={sessionConfig.isDisabled('itemSource', ItemSource.NEW)} value={ItemSource.NEW}>{Localization.t('new-only')}</Choice>
      </Choices>
    );
  },
});

export const ChoicesGoalSource = React.createClass({
  displayName: 'ChoicesGoalSource',

  propTypes: {
    sessionConfig: React.PropTypes.object.isRequired,
  },

  render() {
    const sessionConfig = this.props.sessionConfig;

    return (
      <Choices {...this.props} value={sessionConfig.goalSource}>
        <Choice disabled={sessionConfig.isDisabled('goalSource', GoalSource.ALL)} value={GoalSource.ALL}>{Localization.t('js_iknow.all')}</Choice>
        <Choice disabled={sessionConfig.isDisabled('goalSource', GoalSource.UNCOMPLETED)} value={GoalSource.UNCOMPLETED}>{Localization.t('in-progress')}</Choice>
        <Choice disabled={sessionConfig.isDisabled('goalSource', GoalSource.COMPLETED)} value={GoalSource.COMPLETED}>{Localization.t('completed')}</Choice>
      </Choices>
    );
  },
});
